import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CreateOrderService } from '../click-it/create-order/cement/Services/create-order.service';
import { AuthServicesService } from '../auth/services/auth-services.service';
import { ToastrService } from 'ngx-toastr';
import { clearReducer } from '../auth/state/auth.actions';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../shared/services/utils.service';
import { MigrationPopupService } from '../click-it/services/migration-popup.service';
@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  localData: any;
  acceptLang: any;
  constructor(
    private store: Store<any>,
    private createOrderService: CreateOrderService,
    private authService: AuthServicesService,
    private toastr: ToastrService,
    private router: Router,
    private utilService: UtilsService,
     private migrattionPopUp: MigrationPopupService
  ) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localData = data?.authReducer;
      });
    if (this.localData?.userDetails?.country?.locale) {
      this.acceptLang = this.localData?.userDetails?.country?.locale;
    } else {
      this.acceptLang = navigator.language;
    }
  }
  errorDetectArray: any = [
    'fetch_products',
    'plants',
    'fetch_payers',
    'fetch_partner_ship_tos',
  ];

  token: any;
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {

    const modifiedRequest = request.clone({
      headers: request.headers
        .append('Pragma', 'no-cache')
        .append('Accept-Language', `${this.acceptLang}`)
        .append('Accept', 'application/hal+json')
        .append('Expires', '0')
        .append('Cache-Control', 'no-cache')
        .append('Api-From', 'WebApp')
        .append(
          'X-SYS',
          `${this.localData?.otpVerifiedDetails?.digital_order_system}`
        )
        .append(
          'x-token-authorization',
          `${this.localData?.otpVerifiedDetails?._user_token}`
        )
        .append('AppVersion', 'v1')
        .append('X-Version', environment.HEROKU_RELEASE_VERSION)
        .append('Permissions-Policy', 'camera=(), microphone=(), geolocation=()')
        .append('App-Name', 'CLICKIT')
    });
    return next.handle(modifiedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 406) {
          this.authService.storeData(error.error);

          error.status === 401 ? this.toastr.error('Session Timedout. Please login again!') : this.toastr.error('Something went wrong with your credentials and you have been logged out.Please login again!')
          this.store.dispatch(clearReducer());
          this.migrattionPopUp.stopPopupCheck();
          localStorage.removeItem('lastPopuptime');
          this.router.navigate(['login']);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
        if (error.status === 400) {
          error.error?.message ? localStorage.setItem('errorMessage', JSON.stringify(error.error?.message)) : localStorage.setItem('errorMessage', JSON.stringify(error.error?.messsage))
          error?.status ? localStorage.setItem('errorStatus',  error.status.toString() ) : localStorage.setItem('errorStatus', error.status.toString() )
        }
        if (error.status === 422) {
          localStorage.setItem('errorMessage', 'Unprocessable Entity');
        }
        if (error.status === 403) {
          console.log(error.status, error)
          localStorage.setItem('corsPolcyMessage', 'Access temporarly blocked due to security reasons. Please try again after 3 hours');
        }
        if (error.status === 425) {
          this.utilService.setUpdatedStatus(true)
        }
        if (error.status === 450) {
          console.log(error.error);
          localStorage.setItem('loginData',JSON.stringify(error.error.data))
          this.utilService.setHolcimUser(true)
        }
        if(error.status === 500){
          this.createOrderService.setError(true);
        }
        let errorMsg = '';
        if (error.error instanceof ErrorEvent) {
          errorMsg = `Error: ${error.error.message}`;
        } else {
          if(error?.error?.ordering_disable){
            errorMsg = `Error Code: ${error.status},  Message: ${error.message}, ordering_disable:${error?.error?.ordering_disable}`;
          }else{
            errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
          }
        }
        if (
          this.errorDetectArray.includes(
            error?.url
              ?.split('/')
            [error?.url?.split('/').length - 1].split('?')[0]
          )
        ) {
          this.createOrderService.setError(true);
        }

        return throwError(() => errorMsg);
      })
    );
  }
}
